var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogOut(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.01 23C10.6108 23 11.0113 22.6 11.0113 22C11.0113 21.4 10.6108 21 10.01 21H5.00375C4.403 21 4.0025 20.6 4.0025 20V4C4.0025 3.4 4.403 3 5.00375 3H10.01C10.6108 3 11.0113 2.6 11.0113 2C11.0113 1.4 10.6108 1 10.01 1H5.00375C3.30163 1 2 2.3 2 4V20C2 21.7 3.30163 23 5.00375 23H10.01ZM21.9249 11.6C22.025 11.9 22.025 12.2 21.9249 12.4C21.9249 12.5 21.8248 12.6 21.7247 12.7L17.7196 16.7C17.5194 16.9 17.219 17 17.0188 17C16.8185 17 16.5181 16.9 16.3179 16.7C15.9174 16.3 15.9174 15.7 16.3179 15.3L18.6208 13H9.00876C8.40801 13 8.00751 12.6 8.00751 12C8.00751 11.4 8.40801 11 9.00876 11H18.6208L16.3179 8.7C15.9174 8.3 15.9174 7.7 16.3179 7.3C16.7184 6.9 17.3191 6.9 17.7196 7.3L21.7247 11.3C21.7747 11.35 21.7998 11.4 21.8248 11.45C21.8498 11.5 21.8748 11.55 21.9249 11.6Z",
    fill: "#EA5455"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogOut);
export default __webpack_public_path__ + "static/media/log-out.c9f23ee6397cf8e667ae74589d2f6b9d.svg";
export { ForwardRef as ReactComponent };